import teamRequestCardActionsComponent from './teamRequestCardActions.component';

let teamRequestCardActionsModule = angular.module('vacations-absences.teamRequestCardActions', [])

.component('teamRequestCardActions', teamRequestCardActionsComponent)

.name;

export default teamRequestCardActionsModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCardActions/teamRequestCardActions.js